import { coreInitiativesTasksLinkDeleteAsyncSlice } from './delete';
import { coreInitiativesTasksLinkPostAsyncSlice } from './post';

export const { requestDeleteCoreInitiativesTasksLink, resetDeleteCoreInitiativesTasksLink } =
	coreInitiativesTasksLinkDeleteAsyncSlice.asyncActionCreators;

export const { requestPostCoreInitiativesTasksLink, resetPostCoreInitiativesTasksLink } =
	coreInitiativesTasksLinkPostAsyncSlice.asyncActionCreators;
